import { redirect } from "react-router-dom";

import { HomePage } from "@src/deprecated/pages/Home";
import { IS_CAPACITOR } from "@src/env";

export function meta() {
  return [
    { title: "Home" },
    { name: "description", content: "Welcome to React Router!" },
  ];
}

export async function clientLoader() {
  // Mobile wrapper spike: land on the promoted v2 UI (now mounted at root)
  // instead of the deprecated one.
  return redirect(IS_CAPACITOR ? "/" : "/login");
}

export default function Home() {
  return <HomePage />;
}
